<template>
  <v-dialog v-model="isOpen" persistent width="1200">
    <!-- <s-toolbar label="Importar Programación de Cosecha" close @close="closeDialog">
      <v-tooltip bottom="">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text black @click="showSelectCultiveModal = true" small>
            <i class="fas fa-download"></i>
          </v-btn>
        </template>
<span>Descargar Plantilla</span>
</v-tooltip>
</s-toolbar> -->

    <v-card class="elevation-4" style="border-radius: 12px; overflow: hidden;">
      <!-- Selectores ocultos para obtener datos iniciales -->
      <div style="display: none;">
        <s-select-definition :def="1171" @getDataInitial="getDataTypeService($event)" />
        <s-select-definition :def="1174" @getDataInitial="getDataTypeProcedencia($event)" />
        <s-select-definition :def="1175" @getDataInitial="getDataTypeDestino($event)" />
        <s-select-definition :def="1230" @getDataInitial="getDataTypePlantaProcesadora($event)" />
        <s-select-definition :def="1396" @getDataInitial="getDataTypeEntradaMercancia($event)" />
        <s-select-definition :def="1236" @getDataInitial="getDataTypeEstado($event)" />
        <s-select-definition :def="1231" @getDataInitial="getDataTypeCarga($event)" />
        <s-select-definition :def="1610" @getDataInitial="getDataTypeNegociacion($event)" />
        <s-select-definition :def="1612" @getDataInitial="getDataTypeMode($event)" />
      </div>

      <!-- Header con gradiente -->
      <v-card-title class="primary white--text pa-6"
        style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
        <v-row align="center" no-gutters>
          <v-col>
            <div class="d-flex align-center">
              <v-icon large color="white" class="mr-3">mdi-file-upload</v-icon>
              <div>
                <h2 class="text-h5 font-weight-bold mb-1">Importación Masiva de Cosechas</h2>
                <p class="mb-0 caption" style="opacity: 0.9;">Descargue la plantilla, complete los datos y cargue el
                  archivo
                </p>
              </div>
            </div>
          </v-col>
          <div class="d-flex" style="gap: 4px;">
            <v-tooltip bottom="">
              <template v-slot:activator="{ on }">
                <v-btn class="inline-block" v-on="on" @click="showSelectCultiveModal = true" fab dark small
                  color="success">
                  <i class="fas fa-download"></i>
                </v-btn>
              </template>
              <span>Descargar Plantilla</span>
            </v-tooltip>
            <v-btn class="inline-block" fab dark small color="primary" @click="closeDialog">
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-row>
      </v-card-title>

      <v-container class="pa-3">
        <v-row justify="center">
          <v-col cols="12" md="10" lg="8">
            <v-card outlined class="pa-3 rounded-xl"
              style="border: 2px dashed #1976d2; border-radius: 8px; background-color: #f5f9ff;">
              <div class="text-center">
                <h3 class="">Importar Carga Masiva de Cosechas</h3>
                <p class="grey--text text--base">Descargue la plantilla, llene los datos y cargue el archivo aquí</p>
              </div>
              <div>
                <v-file-input v-model="excelFile" label="Seleccionar archivo Excel para cargar" accept=".xlsx,.xls"
                  @change="handleFileSelect()" small-chips show-size prepend-icon="mdi-file-upload"></v-file-input>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <AlertSunshine :dialog="loadingImport" />

      <!-- <v-overlay :value="loadingImport">
        <v-progress-circular indeterminate size="64">
          Loading...
        </v-progress-circular>
      </v-overlay> -->

      <!-- Vista previa de datos cargados -->
      <v-col cols="12">
        <v-row v-if="headersData.length > 0" class="">
          <v-col cols="12">
            <v-card outlined style="border-radius: 8px;">
              <v-card-title class="pb-2">
                <v-icon color="primary" class="mr-2">mdi-table-eye</v-icon>
                <span class="text-h6 font-weight-medium">Vista Previa de Datos</span>
                <v-spacer></v-spacer>
                <v-chip color="info" outlined small>
                  {{ headersData.length }} registros
                </v-chip>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pa-0">
                <v-data-table :headers="headersTablePreview" :items="headersData" :items-per-page="10"
                  class="elevation-0" loading-text="Cargando datos...">
                  <template v-slot:item.validationStatus="{ item }">
                    <div v-if="item.status">
                      <v-chip v-if="item.status === 'success'" color="success" small outlined>
                        <v-icon left x-small>mdi-check-circle</v-icon>
                        Validado
                      </v-chip>
                      <v-tooltip v-else-if="item.status === 'error'" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip color="error" small outlined v-bind="attrs" v-on="on">
                            <v-icon left x-small>mdi-alert-circle</v-icon>
                            Error
                          </v-chip>
                        </template>
                        <span>{{ item.message }}</span>
                      </v-tooltip>
                    </div>
                    <div v-else>
                      <v-chip color="warning" small outlined>
                        <v-icon left x-small>mdi-clock-outline</v-icon>
                        Validando...
                      </v-chip>
                    </div>
                  </template>

                  <template v-slot:item.actions="{ item, index }">
                    <v-btn x-small color="primary" @click="viewDetail(item)">
                      <v-icon small>mdi-eye</v-icon>
                      Ver
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Sección de acciones -->
        <v-row v-if="headersData.length > 0" class="">
          <v-col cols="12">
            <!-- <v-divider class="mb-6"></v-divider> -->
            <div class="d-flex justify-end">
              <v-btn large outlined color="grey darken-1" class="mr-3 text-none" @click="closeDialog">
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
              <v-btn large color="success" class="text-none px-8" @click="saveDataExcel()" :loading="savingData"
                :disabled="savingData">
                <v-icon left>mdi-content-save</v-icon>
                Guardar Registros
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <!-- Modal anidado para seleccionar Tipo Cultivo -->
    <v-dialog v-model="showSelectCultiveModal" persistent width="500">
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Seleccionar Tipo Cultivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showSelectCultiveModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-6">
          <s-select-definition v-model="selectedTypeCultive" :def="1173" label="Tipo Cultivo" clearable full
            autofocus />
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="showSelectCultiveModal = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="confirmAndDownload()"
            :disabled="!selectedTypeCultive || selectedTypeCultive === 0">
            Descargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Componente de Vista Previa -->
    <HarvestScheduleImportPreview :show.sync="showDetailPreview" :selectedRowIndex="selectedRowIndex"
      :detailData="selectedDetailData" @close="showDetailPreview = false" />
  </v-dialog>
</template>

<script>
import _sFarm from "@/services/Technicalassistance/AgriculturalFarmsService";
import _HSServiceMaterial from "@/services/Technicalassistance/MaintainerCropArticleSap/MaintainerCropArticleSapService";
import _sHarvest from "@/services/Technicalassistance/HarvestSchedule";
import _sAsistementDriverVehicle from "@/services/Technicalassistance/AsignmentSuperviceForeman";
import sAsistementDriverVehicle from "../../services/Technicalassistance/AssistementDriverVehicle";
import HarvestScheduleImportPreview from "@/components/HarvestSchedule/HarvestScheduleImportPreview.vue";

export default {
  components: {
    HarvestScheduleImportPreview,
  },
  name: "HarvestScheduleImportModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      excelFile: null,
      importedData: [],
      importHeaders: [],
      materialsList: [],
      selectedTypeCultive: 0,
      showSelectCultiveModal: false,
      headersData: [],
      loadingImport: false,
      foremenData: [],
      transportData: [],
      headersTablePreview: [],
      validationResults: {}, // Almacenar resultados de validación por Fila
      showDetailPreview: false,
      selectedRowIndex: 0,
      selectedDetailData: null,
      // Datos de select para validación
      itemsTypeService: [],
      itemsTypeOrigin: [],
      itemsTypeDestino: [],
      itemsTypeProcessingPlant: [],
      itemsTypeEntryMerchandise: [],
      itemsTypeEstate: [],
      itemsTypeBurden: [],
      itemsTypeMode: [],
      // Cache de capataces
      foremenList: [],
      foremenByName: {},
      // Cache de supervisores
      superviceList: [],
      superviceByName: {},
      // Errores de guardado
      recordsWithErrorSaved: [],
      RecordsSavedSuccessfully: [],
      showErrorsModal: false,
      savingData: false,
      itemsTypeNegociation: [],
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    async confirmAndDownload() {
      this.showSelectCultiveModal = false;
      await this.loadMaterials();
      this.downloadTemplate();
    },

    loadMaterials() {
      // Cargar materiales del tipo cultivo seleccionado (returns Promise)
      return new Promise((resolve) => {
        if (!this.selectedTypeCultive || this.selectedTypeCultive === 0) {
          resolve();
          return;
        }

        _HSServiceMaterial.listMaterial(this.selectedTypeCultive, this.$fun.getUserID())
          .then((response) => {
            this.materialsList = response.data || [];
            resolve();
          })
          .catch((error) => {
            resolve();
          });
      });
    },

    detectAndLoadMaterials() {
      return new Promise((resolve) => {
        let typeCultiveAUsar = this.selectedTypeCultive;

        if (!typeCultiveAUsar || typeCultiveAUsar === 0) {
          // Intentar obtener del primer registro validado
          if (this.validationResults && Object.keys(this.validationResults).length > 0) {
            const firstResult = this.validationResults[Object.keys(this.validationResults)[0]];
            if (firstResult && firstResult.validatedRecord) {
              typeCultiveAUsar = firstResult.validatedRecord.TypeCultive;
            }
          }
        }

        if (!typeCultiveAUsar || typeCultiveAUsar === 0) {
          resolve();
          return;
        }

        _HSServiceMaterial.listMaterial(typeCultiveAUsar, this.$fun.getUserID())
          .then((response) => {
            this.materialsList = response.data || [];
            resolve();
          })
          .catch((error) => {
            resolve();
          });
      });
    },

    // ================= CAPATACES: carga y matching =================
    normalizeName(str) {
      return (str || '').toString().trim().toLowerCase();
    },

    async loadForemen(search = '') {
      try {
        const resp = await _sHarvest.listForeman(0, search, this.$fun.getUserID());
        const list = resp?.data || [];
        // Si es búsqueda específica, fusionar al cache; si es carga general, reemplazar lista y cache completo
        if (!search) {
          this.foremenList = list;
        }
        // Construir/actualizar índice por nombre
        list.forEach(f => {
          const key = this.normalizeName(f.Foreman);
          if (key && !this.foremenByName[key]) {
            this.foremenByName[key] = f;
          }
        });
        return list;
      } catch (e) {
        return [];
      }
    },

    async ensureForemenLoaded() {
      if (!this.foremenList || this.foremenList.length === 0) {
        await this.loadForemen('');
      }
    },

    matchForemanByName(name) {
      const key = this.normalizeName(name);
      return this.foremenByName[key] || null;
    },

    async searchForemanByName(name) {
      const key = this.normalizeName(name);
      if (this.foremenByName[key]) return this.foremenByName[key];
      const list = await this.loadForemen(name);
      // Buscar coincidencia exacta por nombre (case-insensitive)
      const found = (list || []).find(f => this.normalizeName(f.Foreman) === key) || null;
      if (found) {
        this.foremenByName[key] = found;
      }
      return found;
    },

    // ================= SUPERVISORES: carga y matching =================
    async loadSupervices(search = '') {
      try {
        const resp = await _sHarvest.listSupervice(0, search, this.$fun.getUserID());
        const list = resp?.data || [];
        // Si es búsqueda específica, fusionar al cache; si es carga general, reemplazar lista y cache completo
        if (!search) {
          this.superviceList = list;
        }
        // Construir/actualizar índice por nombre
        list.forEach(s => {
          const key = this.normalizeName(s.Supervice);
          if (key && !this.superviceByName[key]) {
            this.superviceByName[key] = s;
          }
        });
        return list;
      } catch (e) {
        return [];
      }
    },

    matchSuperviceByName(name) {
      const key = this.normalizeName(name);
      return this.superviceByName[key] || null;
    },

    async searchSupervisorByName(name) {
      const key = this.normalizeName(name);
      if (this.superviceByName[key]) return this.superviceByName[key];
      const list = await this.loadSupervices(name);
      // Buscar coincidencia exacta por nombre (case-insensitive)
      const found = (list || []).find(s => this.normalizeName(s.Supervice) === key) || null;
      if (found) {
        this.superviceByName[key] = found;
      }
      return found;
    },

    downloadTemplate() {
      // Obtener materiales del tipo cultivo seleccionado
      _HSServiceMaterial.listMaterial(this.selectedTypeCultive, this.$fun.getUserID())
        .then((response) => {
          console.log(response.data)
          this.materialsList = response.data || [];
          this.createExcelTemplate();
        })
        .catch((error) => {
          this.$fun.alert("Error al obtener materiales", "error");
        });
    },

    createExcelTemplate() {
      try {
        const ExcelJS = require("exceljs");
        const workbook = new ExcelJS.Workbook();

        const myColors = ['FF81C784', 'FFFB8C94', 'FFFFFFB3']
        const worksheet = workbook.addWorksheet("Datos Generales");
        const colorRangos = []
        const myHeaders = this.generateHeaders();

        let start = 0, end = 0;
        myHeaders.forEach((array, index) => {
          end += array.length
          colorRangos.push({
            start: start + 1,
            end,
            color: myColors[index]
          });
          start += array.length
        })

        // console.log(Object.values(myHeaders).flat(), colorRangos)
        this.aplicarFilaEncabezadoUnico(worksheet, 1, Object.values(myHeaders).flat(), colorRangos);
        this.ajustarColumnas(worksheet, Object.values(myHeaders).flat().length);

        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "Plantilla_HarvestSchedule.xlsx";
          link.click();
          this.$fun.alert("Plantilla descargada correctamente", "success");
        });
      } catch (error) {
        console.log(error)
        this.$fun.alert("Error al descargar la plantilla", "error");
      }
    },

    generateHeaders() {
      const headers = [];
      headers.push([
        "Fila", "Fecha", "Tipo Servicio", "Procedencia",
        "Destino", "Planta Procesadora", "ID",
        "Supervisor", "Observación", "Tipo de Entrada de Mercancía",
        "Tipo de Carga", "Estado", "Tipo Negociación", "Modalidad de Traslado"
      ])

      headers.push(['Placa'])
      const materiales = this.materialsList.map(m => m.MtrMaterial);
      headers.push(['Capataz', 'Lote', 'N° Cosechadores', 'N° Jabas', 'Vehiculo', ...materiales]);
      return headers;
    },

    aplicarFilaEncabezadoUnico(ws, rowIndex, headers, sectionColors) {
      const row = ws.getRow(rowIndex);
      row.values = headers;
      row.height = 45;

      row.eachCell((cell, colNumber) => {
        // Buscar a qué sección pertenece esta celda
        const section = sectionColors.find(s => colNumber >= s.start && colNumber <= s.end);
        const bgColor = section ? section.color : 'FFFFFFFF';

        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: bgColor },
        };
        cell.font = { bold: true, color: { argb: 'FF000000' }, size: 11 };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    },

    ajustarColumnas(worksheet, totalCols) {
      for (let i = 1; i <= totalCols; i++) {
        const col = worksheet.getColumn(i);
        // col.width = 18;
        let maxLength = 0;

        col.eachCell({ includeEmpty: false }, (cell) => {
          const cellLength = cell.value ? cell.value.toString().length : 0;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        });

        // Ajustar ancho basado en el contenido (mínimo 15, máximo 30)
        col.width = Math.min(Math.max(maxLength + 2, 15), 30);
      }
      // worksheet.getColumn(1).width = 8;
      // worksheet.getColumn(2).width = 22;
    },

    async handleFileSelect() {
      this.loadingImport = true;
      if (!this.excelFile) {
        this.loadingImport = false;
        this.headersData = [];
        this.validationResults = [];
        this.foremenData = [];
        this.transportData = [];
        return;
      }

      this.headersData = [];
      this.validationResults = [];
      this.foremenData = [];
      this.transportData = [];
      this.loadingImport = true;

      try {
        const ExcelJS = require("exceljs");
        const reader = new FileReader();

        reader.onload = async (e) => {
          const workbook = new ExcelJS.Workbook();
          workbook.xlsx.load(e.target.result).then(async () => {
            // Leer Hoja 1: Datos Generales
            const wsHeaders = workbook.getWorksheet("Datos Generales");

            if (!wsHeaders) {
              this.$fun.alert("El archivo debe contener la hoja de Datos Generales", "warning");
              return;
            }

            // Procesar Datos Generales
            const headersWs = this.leerRowsSheet(wsHeaders);
            const rowsTable = headersWs.map(item => ({ ...item.general, ...item.capataces, ...item.transporte }));

            this.foremenData = headersWs.map(x => x.capataces).filter(x => this.VerifyObjectValue(x));
            this.transportData = headersWs.map(x => x.transporte).filter(x => this.VerifyObjectValue(x));

            // Generar headers dinámicos con todos los campos de la plantilla
            this.generateDynamicHeaders(wsHeaders);
            // Mapear todos los registros del Excel
            this.headersData = await this.validateAllRecords(rowsTable);
            this.loadingImport = false;

            this.$fun.alert(
              `Cargado: ${this.headersData.length} registros, ${this.foremenData.length} capataces, ${this.transportData.length} transportes`,
              "success"
            );
          });
        };

        reader.readAsArrayBuffer(this.excelFile);
      } catch (error) {
        this.$fun.alert("Error al procesar el archivo Excel", "error");
      }
    },

    leerRowsSheet(ws) {
      const filas = [];
      const headerRow = ws.getRow(1);
      const headersSheet = headerRow.values.slice(1); // [0] es undefined
      const nameHeaders = this.generateHeaders();

      // === LEER FILAS DE DATOS (fila 2 en adelante) ===
      ws.eachRow({ includeEmpty: false }, (row, rowNumber) => {

        if (rowNumber === 1) return; // Saltar encabezado
        const values = row.values;
        let fila = { general: {}, transporte: {}, capataces: {} };

        Object.keys(fila).forEach((group, index) => {
          let item = {};
          nameHeaders[index].forEach((h) => {
            const indexHeader = headersSheet.indexOf(h)
            item[h] = values[indexHeader + 1];
            item["Fila"] = values[1]
          })
          fila[group] = item;
        })

        filas.push(fila);
      });

      return filas;
    },

    VerifyObjectValue: (obj) => {
      if (!obj || typeof obj !== 'object') return false;
      return Object.values(obj).some(valor => {
        if (valor === null || valor === undefined) return false;
        if (typeof valor === 'string') return valor.trim() !== '';
        if (typeof valor === 'number') return true;
        if (typeof valor === 'boolean') return true;
        if (Array.isArray(valor)) return valor.length > 0;
        if (typeof valor === 'object') return Object.keys(valor).length > 0;
        return true; // por si acaso
      });
    },

    processSheet(worksheet) {
      const headers = [];
      worksheet.getRow(1).eachCell((cell) => {
        headers.push(cell.value);
      });

      const jsonData = [];
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          const rowData = {};
          row.eachCell((cell, colNumber) => {
            rowData[headers[colNumber - 1]] = cell.value;
          });
          // Agregar fecha formateada si existe la columna Fecha
          if (rowData.Fecha) {
            rowData.FechaFormateada = this.formatDateForTable(rowData.Fecha);
          }
          jsonData.push(rowData);
        }
      });

      return jsonData;
    },

    generateDynamicHeaders(worksheet) {
      const headers = [];
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (cell.value) {
          // Si la columna es Fecha, agregar columna formateada
          if (cell.value.toString() === 'Fecha') {
            headers.push({
              text: 'Fecha (DD/MM/YYYY)',
              value: 'FechaFormateada',
              width: 120,
            });
          } else {
            headers.push({
              text: cell.value.toString(),
              value: cell.value.toString(),
              width: cell.value.toString() === 'Fila' ? 50 : 120,
              align: cell.value.toString() === 'Fila' ? 'center' : '',
            });
          }
        }
      });

      // Agregar columna de Estado de Validación
      headers.push({
        text: "Estado Cod Senasa",
        value: "validationStatus",
        width: 150,
        sortable: false,
      });

      // Agregar columna de Acciones
      headers.push({
        text: "Acciones",
        value: "actions",
        width: 100,
        sortable: false,
      });

      this.headersTablePreview = headers;
    },

    getDataTypeService(items) {
      this.itemsTypeService = items;
    },

    getDataTypeProcedencia(items) {
      this.itemsTypeOrigin = items;
    },

    getDataTypeDestino(items) {
      this.itemsTypeDestino = items;
    },

    getDataTypePlantaProcesadora(items) {
      this.itemsTypeProcessingPlant = items;
    },

    getDataTypeEntradaMercancia(items) {
      this.itemsTypeEntryMerchandise = items;
    },

    getDataTypeEstado(items) {
      this.itemsTypeEstate = items;
    },

    getDataTypeCarga(items) {
      this.itemsTypeBurden = items;
    },

    getDataTypeNegociacion(items) {
      this.itemsTypeNegociation = items;
    },

    getDataTypeMode(items) {
      this.itemsTypeMode = items;
      console.log(this.itemsTypeMode);
    },

    async validateAllRecords(rowsImport = []) {
      const formatedRows = [];
      // Si no tenemos materiales cargados, intentar cargarlos
      if (!this.materialsList || this.materialsList.length === 0) {
        await this.detectAndLoadMaterials();
      }

      const lotesId = [...new Set(rowsImport.map(r => r["ID"]).filter(c => c && c.toString().trim() !== ''))];

      let arrayFltIDs = [];
      if (lotesId.length > 0) {
        arrayFltIDs = await this.getFarmsByFltIDs({ FltIDs: lotesId, FagID: 0 })
      }

      for (let index = 0; index < rowsImport.length; index++) {
        let record = rowsImport[index];
        const { Fila: filaNum } = record

        if (record.Fecha) {
          record.FechaFormateada = this.formatDateForTable(record.Fecha);
        }

        if (record["ID"]) {
          // Validar contra el servicio (similar a HarvestScheduleEdit)
          const data = arrayFltIDs.find(x => x.FltID == record["ID"]);
          const validatedRecord = await this.mapHeaderValues(record, data);
          const dataMessage = {
            status: data ? "success" : "error",
            message: data ? "Validado correctamente" : "No encontrado"
          }

          // Lo dejo asi nomas para que se muestren todas las filas cargadas del excel.

          if (data) {
            const formated = { ...record, ...dataMessage, data, validatedRecord: validatedRecord }
            this.$set(this.validationResults, filaNum, { ...dataMessage, validatedRecord: validatedRecord });
            record = { ...formated }
          } else {
            const formated = { ...record, ...dataMessage }
            this.$set(this.validationResults, filaNum, { ...dataMessage, validatedRecord: validatedRecord });
            record = { ...formated }
          }
        } else {
          this.$set(this.validationResults, filaNum, { ...record, status: "error", message: "Fila vacía" });
          record = { ...record, status: "error", message: "Fila vacía" }
        }

        formatedRows.push(record);
      }

      return formatedRows;
    },

    async mapHeaderValues(record, objLot) {
      // Asegurar que supervisores estén cargados
      if (!this.superviceList || this.superviceList.length === 0) {
        await this.loadSupervices('');
      }

      let genSuperviceId = 0;
      const nameSupervisor = (record.Supervisor || '').toString();
      if (nameSupervisor) {
        let supervisor = this.matchSuperviceByName(nameSupervisor);
        if (!supervisor) {
          supervisor = await this.searchSupervisorByName(nameSupervisor);
        }
        if (supervisor) {
          // Intentar varios nombres de campo
          genSuperviceId = supervisor.NtpSuperviceID || supervisor.SpvID || supervisor.ID || 0;
        }
      }

      const validatedRecord = {
        Fila: record.Fila,
        Fecha: record.Fecha,
        FltID: record["ID"],
        CodSenasa: objLot ? objLot.FltCodSenasa : null,
        Observacion: record.Observación,
        GenSuperviceID: genSuperviceId,
      };

      // Mapear Tipo Servicio
      if (record["Tipo Servicio"]) {
        const servicetype = this.itemsTypeService.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record["Tipo Servicio"]));
        validatedRecord.TypeService = servicetype ? servicetype.DedValue : null;
        validatedRecord.TypeServiceDesc = servicetype ? servicetype.DedDescription : record["Tipo Servicio"];
      }

      // Mapear Procedencia
      if (record.Procedencia) {
        const origin = this.itemsTypeOrigin.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record.Procedencia));
        validatedRecord.TypeOrigin = origin ? origin.DedValue : null;
        validatedRecord.TypeOriginDesc = origin ? origin.DedDescription : record.Procedencia;
        validatedRecord.Procedencia = origin ? origin.DedDescription : record.Procedencia;
      }

      // Mapear Destino
      if (record.Destino) {
        const destination = this.itemsTypeDestino.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record.Destino));
        validatedRecord.TypeDestination = destination ? destination.DedValue : null;
        validatedRecord.TypeDestinationDesc = destination ? destination.DedDescription : record.Destino;
        record.Destino = destination ? destination.DedDescription : record.Destino;
      }

      // Mapear Planta Procesadora
      if (record["Planta Procesadora"]) {
        const plantprocessor = this.itemsTypeProcessingPlant.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record["Planta Procesadora"]));
        validatedRecord.TypeProcessingPlant = plantprocessor ? plantprocessor.DedValue : null;
        validatedRecord.TypeProcessingPlantDesc = plantprocessor ? plantprocessor.DedDescription : record["Planta Procesadora"];
      }

      // Mapear Tipo Entrada de Mercancía
      if (record["Tipo de Entrada de Mercancía"]) {
        const entryType = this.itemsTypeEntryMerchandise.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record["Tipo de Entrada de Mercancía"]));
        validatedRecord.TypeEntryMerchandise = entryType ? entryType.DedValue : null;
        validatedRecord.TypeEntryMerchandiseDesc = entryType ? entryType.DedDescription : record["Tipo de Entrada de Mercancía"];
      }

      // Mapear Estado
      if (record.Estado) {
        const status = this.itemsTypeEstate.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record.Estado));
        validatedRecord.Status = status ? status.DedValue : null;
        validatedRecord.StatusDesc = status ? status.DedDescription : record.Estado;
        validatedRecord.Estado = status ? status.DedDescription : record.Estado;
      }

      // Mapear Tipo Carga
      if (record["Tipo de Carga"]) {
        const tipoCarga = this.itemsTypeBurden.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record["Tipo de Carga"]));
        validatedRecord.TypeCharge = tipoCarga ? tipoCarga.DedValue : null;
        validatedRecord.TypeChargeDesc = tipoCarga ? tipoCarga.DedDescription : record["Tipo de Carga"];
      }

      // Mapear Tipo Negociación
      if (record["Tipo Negociación"]) {
        const typeNegociation = this.itemsTypeNegociation.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record["Tipo Negociación"]));
        validatedRecord.TypeNegociation = typeNegociation ? typeNegociation.DedValue : null;
        validatedRecord.TypeNegociationDesc = typeNegociation ? typeNegociation.DedDescription : record["Tipo Negociación"];
      }

       // Mapear Modalidad de Traslado
      if (record["Modalidad de Traslado"]) {
        const typeMode = this.itemsTypeMode.find((x) => this.normalizeName(x.DedDescription) === this.normalizeName(record["Modalidad de Traslado"]));
        validatedRecord.typeMode = typeMode ? typeMode.DedValue : null;
        validatedRecord.typeModeDesc = typeMode ? typeMode.DedDescription : record["Modalidad de Traslado"];
      }

      if (objLot) {
        validatedRecord.FltID = objLot.FltID;
        validatedRecord.FltName = objLot.FltName;
        validatedRecord.FagID = objLot.FagID;
        validatedRecord.FagName = objLot.FagName;
        validatedRecord.PrdID = objLot.PrdID;
        validatedRecord.PrdText = objLot.PrdText;
        validatedRecord.VrtID = objLot.VrtID;
        validatedRecord.VrtDescription = objLot.VrtDescription;
        validatedRecord.VrtText = objLot.VrtText; //Nuevo
        validatedRecord.TypeCultive = objLot.TypeCultive;
        validatedRecord.TypeCultiveText = objLot.TypeCultiveText;
        validatedRecord.TypeCrop = objLot.TypeCrop;
        validatedRecord.TypeCropText = objLot.TypeCropText;
        validatedRecord.FagAddress = objLot.FagAddress;
        validatedRecord.ZonIDText = objLot.ZonIDText;
        validatedRecord.SzoIDText = objLot.SzoIDText;
      }

      const filaNum = record.Fila;
      validatedRecord.DetailsGenForeman = this.foremenData.filter(c => c.Fila === filaNum);
      validatedRecord.DetailsTransport = this.transportData.filter(t => t.Fila === filaNum);

      return validatedRecord;
    },

    async getFarmsByFltIDs(objFilter) {
      try {
        const response = await _sFarm.listFarmByFltIDs(objFilter, this.$fun.getUserID());
        return response.data;
      } catch (error) {
        console.error('Error obteniendo códigos de Senasa:', error);
        return [];
      }
    },

    viewDetail(item) {
      // Filtrar capataces y transporte por Fila
      // const capatacesFiltered = this.foremenData.filter((c) => c.Fila === item.Fila);
      // const transporteFiltered = this.transportData.filter((t) => t.Fila === filaNum);
      const capatacesFiltered = this.foremenData.filter((c) => c.Fila === item.Fila);
      const transporteFiltered = this.transportData.filter((t) => t.Fila === item.Fila);

      this.selectedDetailData = {
        header: item,
        senasaData: item?.data, // Datos del lote desde la validación
        capataces: capatacesFiltered,
        capatacesHeaders: [
          { text: "Capataz", value: "Capataz" },
          { text: "Lote", value: "Lote" },
          { text: "N° Cosechadores", value: "N° Cosechadores" },
          { text: "N° Jabas", value: "N° Jabas" },
          { text: "Vehiculo", value: "Vehiculo" },
        ],
        transporte: transporteFiltered,
        transporteHeaders: [
          { text: "Placa", value: "Placa" },
        ],
      };
      console.log({ selectedDetailData: this.selectedDetailData })
      this.showDetailPreview = true;
    },

    formatDate(data) {
      if (!data) return null;

      let date;

      // Si es string de fecha GMT, extraer directamente
      if (typeof data === 'string' && data.includes('GMT')) {
        const dateObj = new Date(data);

        const localDate = new Date(dateObj.getTime() + 5 * 60 * 60 * 1000);
        date = localDate;
      } else {
        date = new Date(data);
        // Sumar horas para compensar zona horaria
        date = new Date(date.getTime() + 5 * 60 * 60 * 1000);
      }

      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      const result = `${year}-${month}-${day}`;
      return result;
    },

    formatDateForTable(data) {

      if (!data) return '';

      let date;

      if (typeof data === 'string' && data.includes('GMT')) {
        const dateObj = new Date(data);
        date = new Date(dateObj.getTime() + 5 * 60 * 60 * 1000);
      } else {
        date = new Date(data);
        date = new Date(date.getTime() + 5 * 60 * 60 * 1000);
      }

      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },

    async processDetailsForemen(foremenData, fltID, frgID, prdID, typeCharge, hvsQuantity, typeCultive, usrID, line = 1) {

      const detailsProcessed = [];

      if (!foremenData || foremenData.length === 0) {
        return detailsProcessed;
      }

      await this.ensureForemenLoaded();

      for (let index = 0; index < foremenData.length; index++) {
        const capataz = foremenData[index];

        let genForemanId = 0;
        const nameForeman = (capataz.Capataz || '').toString();
        if (nameForeman) {
          let foreman = this.matchForemanByName(nameForeman);
          if (!foreman) {
            foreman = await this.searchForemanByName(nameForeman);
          }

          if (foreman) {
            genForemanId = foreman.NtpID || 0;
          }
        }

        const detail = {
          GfrID: 0,
          HvsID: 0,
          FltID: fltID,
          FagID: frgID,
          PrdID: prdID,
          GenForemanID: genForemanId,
          Foreman: nameForeman,
          HvsQuantityPerson: parseInt(capataz["N° Cosechadores"]) || 0,
          HvsQuantityMaterial: parseInt(capataz["N° Jabas"]) || 0,
          VehPlate: capataz.Vehiculo || '',
          NtpIDDriver: 0,
          DriverName: '',
          FltName: '',
          Line: line + index,
          UsrCreateID: usrID,
          UsrUpdateID: usrID,
          SecStatus: 1,
          DetailsMaterial: await this.processMaterials(capataz, typeCultive, usrID),
        };

        if (capataz.Vehiculo) {
          try {
            const response = await sAsistementDriverVehicle.listVehicle(
              typeCharge,
              hvsQuantity,
              capataz.Vehiculo,
              usrID
            );

            if (response.data && response.data.length > 0) {
              const vehicle = response.data[0];
              detail.DriverName = vehicle.Driver || '';
              detail.NtpIDDriver = vehicle.NtpIDDriver || 0;
            }
          } catch (error) {

          }
        }

        detailsProcessed.push(detail);
      }

      return detailsProcessed;
    },

    async processMaterials(capatazRow, typeCultive, usrID) {

      const materials = [];

      if (!capatazRow) {
        return materials;
      }

      let materialesList = [];
      if (typeCultive) {
        try {
          const resp = await _HSServiceMaterial.listMaterial(typeCultive, usrID);
          materialesList = resp?.data || [];
        } catch (error) {
        }
      }

      Object.keys(capatazRow).forEach((key) => {
        if (['Fila', 'Capataz', 'Lote', 'N° Cosechadores', 'N° Jabas', 'Vehiculo'].includes(key)) {
          return;
        }

        const quantity = parseInt(capatazRow[key]) || 0;
        if (quantity > 0) {
          const materialFound = (materialesList || []).find(m =>
            m.MtrMaterial && m.MtrMaterial.toLowerCase() === key.toLowerCase()
          );

          const material = {
            GfrID: 0,
            ArcID: materialFound ? materialFound.ArtID : 0,
            MtrID: materialFound ? materialFound.ArtID : 0,
            MtrMaterial: key,
            MtrQuantity: quantity,
            UsrCreateID: usrID,
            UsrUpdateID: usrID,
            SecStatus: 1,
          };


          materials.push(material);
        }
      });

      return materials;
    },

    async ProcessingDetails(transporteData, typeCharge, hvsQuantity, usrID, line = 1) {
      // Procesar detalles de transporte desde el Excel
      const detailsProcessed = [];

      if (!transporteData || transporteData.length === 0) {
        return detailsProcessed;
      }

      for (let index = 0; index < transporteData.length; index++) {
        const transport = transporteData[index];
        const plate = transport.Placa;

        if (!plate) {
          continue;
        }

        try {
          const Quantity = hvsQuantity || 0;
          const VehPlate = plate || '';
          // Llamar al servicio para obtener datos del vehículo
          const response = await sAsistementDriverVehicle.listVehicle(
            typeCharge,
            Quantity,
            VehPlate,
            this.$fun.getUserID()
          );
          if (response.data && response.data.length > 0) {

            const vehicle = response.data[0];

            const detail = {
              TptID: 0,
              HvsID: 0,
              Line: line + index,
              TptDriver: vehicle.Driver || '',
              TptEnrollment: vehicle.VehPlate || plate,
              TptVehicle: vehicle.TypeVehicleText || '',
              TptTon: vehicle.CfvCapacity || 0,
              TypeLoad: 1,
              UsrCreateID: usrID,
              UsrUpdateID: usrID,
              SecStatus: 1,
            };

            detailsProcessed.push(detail);
          } else {

            const detail = {
              TptID: 0,
              HvsID: 0,
              Line: line + index,
              TptDriver: 'No encontrado',
              TptEnrollment: plate,
              TptVehicle: 'No encontrado',
              TptTon: 0,
              TypeLoad: 1,
              UsrCreateID: usrID,
              UsrUpdateID: usrID,
              SecStatus: 1,
            };
            detailsProcessed.push(detail);
          }
        } catch (error) {
          // Agregar registro con error
          const detail = {
            TptID: 0,
            HvsID: 0,
            Line: line + index,
            TptDriver: 'Error',
            TptEnrollment: plate,
            TptVehicle: 'Error',
            TptTon: 0,
            TypeLoad: 1,
            UsrCreateID: usrID,
            UsrUpdateID: usrID,
            SecStatus: 1,
          };
          detailsProcessed.push(detail);
        }
      }

      return detailsProcessed;
    },

    async ItemForSave(validatedRecord) {
      // Construir item similar a HarvestScheduleEdit.save()
      // Primero calcular HvsQuantity básico desde capataces
      let hvsQuantityBasico = 0;
      if (validatedRecord.DetailsGenForeman && validatedRecord.DetailsGenForeman.length > 0) {
        validatedRecord.DetailsGenForeman.forEach((cap) => {
          hvsQuantityBasico += parseInt(cap["N° Jabas"]) || 0;
        });
      }

      // Procesar capataces CON datos de vehículos
      const detailsForeman = await this.processDetailsForemen(
        validatedRecord.DetailsGenForeman || [],
        validatedRecord.FltID,
        validatedRecord.FagID,
        validatedRecord.PrdID,
        validatedRecord.TypeCharge,
        hvsQuantityBasico,
        validatedRecord.TypeCultive,
        this.$fun.getUserID()
      );

      // Calcular HvsQuantity desde capataces
      let hvsQuantity = 0;
      if (detailsForeman && Array.isArray(detailsForeman) && detailsForeman.length > 0) {
        detailsForeman.forEach((frm) => {
          const HvsQuantityMaterial = parseInt(frm.HvsQuantityMaterial) || 0;
          hvsQuantity += HvsQuantityMaterial;
        });
      }

      // Procesar detalles de transporte CON la cantidad correcta
      const detailsTransport = await this.ProcessingDetails(
        validatedRecord.DetailsTransport || [],
        validatedRecord.TypeCharge,
        hvsQuantity, // Usar cantidad calculada
        this.$fun.getUserID()
      );

      const item = {
        HvsID: 0, // Nuevo registro
        HvsNumber: 0,
        HvsDate: this.formatDate(validatedRecord.Fecha),
        TypeService: validatedRecord.TypeService,
        TypeOrigin: validatedRecord.TypeOrigin,
        TypeDestination: validatedRecord.TypeDestination,
        TypeProcessingPlant: validatedRecord.TypeProcessingPlant,
        TypeEntryMerchandise: validatedRecord.TypeEntryMerchandise,
        TypeCharge: validatedRecord.TypeCharge,
        HvsStatus: validatedRecord.Status,
        Observation: validatedRecord.Observacion,
        TypeNegociation: validatedRecord.TypeNegociation,
        TypeMode: validatedRecord.TypeMode,
        TypeUnitJaba: null,
        IncludesMaterialsJaba: null,
        TypeUnitMaterials: null,
        TypeUnitPersonnelTransportation: null,
        TypeHarvest: validatedRecord.TypeHarvest || null,
        ObservationTypeUnit: null,
        // Campos del Lote
        FltID: validatedRecord.FltID,
        FagID: validatedRecord.FagID,
        PrdID: validatedRecord.PrdID,
        VrtID: validatedRecord.VrtID,
        TypeCultive: validatedRecord.TypeCultive,
        TypeCrop: validatedRecord.TypeCrop,

        // Datos de Usuario
        UsrCreateID: this.$fun.getUserID(),
        UsrUpdateID: this.$fun.getUserID(),

        // Supervisor - Traído del registro validado
        GenSuperviceID: validatedRecord.GenSuperviceID || 0,

        // Detalles - Usar capataces ya procesados
        DetailsGenForeman: detailsForeman,
        DetailsTransport: detailsTransport,

        // Estado y cantidad
        HvsQuantity: hvsQuantity,
        SecStatus: 1,
      };

      // console.log("ITEM LISTO PARA GUARDAR", item);

      return item;
    },

    async saveDataExcel() {
      this.loadingImport = true;
      this.savingData = true;
      // Limpiar arrays de intentos anteriores
      this.recordsWithErrorSaved = [];
      this.RecordsSavedSuccessfully = [];

      // Método para guardar todos los registros válidos del Excel
      const recordsSucess = [];
      const recordsError = [];
      this.validationResults = this.validationResults.map(r => {

        const DetailsTransport = new Set();
        const DetailsGenForeman = new Set();
        r.validatedRecord.DetailsTransport.filter(item => {
          if (DetailsTransport.has(item.Placa)) return false;
          DetailsTransport.add(item.Placa);
          return true;
        });
        // r.validatedRecord.DetailsGenForeman.filter(item => {
        //   if (DetailsGenForeman.has(item.Vehiculo)) return false;
        //   DetailsGenForeman.add(item);
        //   return true;
        // });

        r.validatedRecord.DetailsTransport = Array.from(DetailsTransport);
        // r.validatedRecord.DetailsGenForeman = Array.from(DetailsGenForeman);
        return { ...r }
      })

      // Recorrer todos los registros validados
      // console.log({ validationResults: this.validationResults });
      if (this.validationResults && typeof this.validationResults === 'object') {
        for (const filaNum of Object.keys(this.validationResults)) {
          const validation = this.validationResults[filaNum];

          if (validation && validation.status === "success" && validation.validatedRecord) {
            try {
              const item = await this.ItemForSave(validation.validatedRecord);
              recordsSucess.push(item);
            } catch (error) {
              // console.log({ ItemForSave: error })
              recordsError.push({
                fila: filaNum,
                error: `Error al procesar: ${error.message}`,
              });
            }
          } else if (validation) {
            recordsError.push({
              fila: filaNum,
              error: validation.message || 'Error desconocido',
            });
          }
        }
      }

      if (recordsError.length > 0) {
        this.loadingImport = false;
        this.savingData = false;
        this.$fun.alert(`Se encontraron ${recordsError.length} registros con error. Revise los detalles.`, "warning");
      }

      if (recordsSucess.length === 0) {
        this.loadingImport = false;
        this.savingData = false;
        this.$fun.alert("No hay registros válidos para guardar", "warning");
        return;
      }
      this.savingData = false;
      this.loadingImport = false;
      // Confirmación antes de guardar
      this.$fun.alert(`¿Seguro de guardar ${recordsSucess.length} registros?`, "question").then((re) => {
        if (re.value) {
          this.loadingImport = true;
          this.SaveRecordsOne(recordsSucess, 0);
        }
      });
    },

    SaveRecordsOne(records, indice) {
      if (indice >= records.length) {
        this.showSavedSummary();
        return;
      }

      const item = records[indice];
      const filaNum = item.Fila || (indice + 1);

      _sHarvest.save(item, this.$fun.getUserID()).then((r) => {
        const esSuccess = r && (r.status === 200 || r.status === 201 || r.status === 204 || !r.status);
        if (esSuccess) {
          // Agregar a exitosos
          this.RecordsSavedSuccessfully.push({
            fila: filaNum,
            indice: indice + 1,
            fecha: item.HvsDate,
            codSenasa: item.CodSenasa || 'N/A'
          });
        } else {
          const errorMsg = r?.data?.message || r?.data || r?.statusText || JSON.stringify(r);
          // Agregar a errores
          this.recordsWithErrorSaved.push({
            fila: filaNum,
            indice: indice + 1,
            fecha: item.HvsDate,
            codSenasa: item.CodSenasa || 'N/A',
            error: errorMsg,
            status: r?.status
          });
        }

        this.SaveRecordsOne(records, indice + 1);
      }).catch((error) => {
        const filaNumError = item.Fila || (indice + 1);
        const errorMsg = error?.response?.data?.message || error?.message || JSON.stringify(error);

        // Agregar a errores
        this.recordsWithErrorSaved.push({
          fila: filaNumError,
          indice: indice + 1,
          fecha: item.HvsDate,
          codSenasa: item.CodSenasa || 'N/A',
          error: errorMsg,
          tipo: 'Exception'
        });
        console.log({ errorsave: error })
        // Continuar con el siguiente registro SIEMPRE
        this.SaveRecordsOne(records, indice + 1);
      });
    },

    showSavedSummary() {
      const totalSuccess = (this.RecordsSavedSuccessfully || []).length;
      const totalErrors = (this.recordsWithErrorSaved || []).length;

      if (totalErrors === 0) {
        this.$fun.alert(`¡Excelente! ${totalSuccess} registros guardados correctamente`, "success");
        // this.closeDialog();
      } else if (totalSuccess === 0) {
        this.$fun.alert(`Error: No se pudo guardar ningún registro (${totalErrors} errores)`, "error");
        this.showErrorsModal = true;
      } else {
        this.$fun.alert(`Guardado parcial: ${totalSuccess} exitosos, ${totalErrors} con errores`, "warning");
        this.showErrorsModal = true;
      }

      // this.loadingImport = false;
      this.closeDialog();
    },

    closeDialog() {
      this.loadingImport = false;
      this.isOpen = false;
      this.excelFile = null;
      this.importedData = [];
      this.importHeaders = [];
      this.selectedTypeCultive = 0;
      this.materialsList = [];
      this.showSelectCultiveModal = false;
      this.$emit("close");
      //Resetear Items caregados
      this.foremenData = []
      this.transportData = []
      this.headersData = []
    },
  },
};
</script>

<style scoped>
h3 {
  color: #1976d2;
}

h4 {
  color: #424242;
  margin-bottom: 10px;
}
</style>
